'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _propTypes = require('./prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ErrorTab = _react2['default'].createClass({
    displayName: 'ErrorTab',


    propTypes: _extends({}, _propTypes.CommonTabProps, {
        error: _react2['default'].PropTypes.object,
        onContinue: _react2['default'].PropTypes.func.isRequired
    }),

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'error': new Error('Unknown error')
        };
    },
    getInitialState: function getInitialState() {
        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS
        };
    },


    //  ----  RENDERING  ----------------------------------

    render: function render() {
        var _props = this.props,
            actionBarProps = _props.actionBarProps,
            onContinue = _props.onContinue;


        var inputClasses = {
            'm-sign-modal--tabs--error--input': true
        };
        var classes = {
            'm-sign-modal--tabs--error': true
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };
        var errorClasses = {
            'm-sign-modal--tabs--error-content': true
        };

        var errorMessage = this.props.error.message || '';

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(containerClasses) },
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--tab-title' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.error.title' })
            ),
            _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(classes) },
                _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])(inputClasses) },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-modal--tabs--content' },
                        _react2['default'].createElement(
                            'div',
                            { className: (0, _classnames2['default'])(errorClasses) },
                            _react2['default'].createElement(
                                'h1',
                                null,
                                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.error.header' })
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.error.body' })
                            ),
                            _react2['default'].createElement(
                                'p',
                                { 'data-test-ref': 'error-message' },
                                errorMessage
                            )
                        )
                    )
                )
            ),
            _react2['default'].createElement(_actionBar2['default'], _extends({
                'data-test-ref': 'action-bar'
            }, actionBarProps, {
                continueInsteadOfInsert: true,
                onContinue: onContinue
            }))
        );
    }
});

module.exports = ErrorTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/error-tab.jsx
 ** module id = 796
 ** module chunks = 0 1
 **/